import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  GameSection,
  GameStructure,
  PlayForRealPopup,
  gameConfigStore,
  freeBetStore,
} from '@pascal/pascal-core';
import { WebGameScene } from '../game/webGameScene';
import FooterWr from './footer';
import HeaderWr from './header';
import { PayoutsAndResultsContainer } from './payoutsAndResultsContainer';
import demoLogo from '../assets/images/demo-logo.png';
import {
  AdditionalErrorMessages,
  AdditionalNotificationByResponseCode,
  AdditionalResponseCode,
} from '../enums/notificationsEnum';
import { catchMeGameId, touchMeGameId } from '../enums/gameConstant';
import catchMeGameLogo from '../assets/images/game/catch-me/catch-me-game-logo.png';
import touchMeGameLogo from '../assets/images/game/touch-me/touch-me-game-logo.png';

export const WebGame = observer(() => {
  const { gameId } = gameConfigStore;
  const { activeFreeBet } = freeBetStore;

  const gameLogoDependOnGameId = useMemo(() => {
    const logos = {
      [catchMeGameId]: catchMeGameLogo,
      [touchMeGameId]: touchMeGameLogo,
    };

    return logos[+gameId];
  }, [gameId]);

  return (
    <GameStructure
      hasGameTypeLoading
      hasLobby
      lobbyLogoImageSrc={gameLogoDependOnGameId}
      isShowBogLineLobby
    >
      <HeaderWr gameLogoDependOnGameId={gameLogoDependOnGameId} />
      <GameSection
        haveNotification
        AdditionalResponseCode={AdditionalResponseCode}
        AdditionalErrorMessages={AdditionalErrorMessages}
        AdditionalNotificationByResponseCode={AdditionalNotificationByResponseCode}
        translationValues={{
          minOdd: `x${activeFreeBet.id ? activeFreeBet.minOdd : 1.01}`,
        }}
      >
        <PayoutsAndResultsContainer />
        <WebGameScene />
      </GameSection>
      <FooterWr />
      <PlayForRealPopup popupLogo={demoLogo} />
    </GameStructure>
  );
});
